<template>
  <div>
    <CModal
      title="Mensagem"
      :show.sync="modalMensagem"
      :footer-wrapper="false"
      color="primary"
    >
      <CSelect
        :value.sync="profissionalSelecionado"
        :options="listaProfissionais"
        required
        v-model="profissionalSelecionado"
        prepend="Profissional"
        invalid-feedback="Nome é obrigatório"
      >
      </CSelect>

      <CTextarea
        placeholder="Mensagem"
        horizontal
        rows="5"
        cols="20"
        v-model="texto"
      />

      <CButton color="success" @click="enviarMensagem()"
        >Enviar Mensagem</CButton
      >
      <CButton color="info" class="m-2" @click="voltar()">Voltar</CButton>
    </CModal>
    <CModal
      color="warning"
      :title="'ATENÇÃO'"
      :show.sync="largeModal"
      :footer-wrapper="false"
    >
      <CTextarea
        placeholder="Mensagem"
        horizontal
        rows="5"
        style="font-size: 18px;
        font-weight: 300;"
        v-model="texto"
      />
      <CButton color="success" @click="visto()">Visto</CButton>
      <CButton
        color="primary"
        style="margin-left: 10px"
        v-show="btnVerC"
        @click="perfilConsulta()"
        >Ver Consulta</CButton
      >
      <CButton
        color="primary"
        style="margin-left: 10px"
        v-show="visuBtns"
        @click="abrirModal()"
        >Enviar Mensagem</CButton
      >
    </CModal>
    <CHeader fixed with-subheader light class="header-brand">
      <CToggler
        in-header
        class="ml-3 d-lg-none"
        @click="$store.commit('toggleSidebarMobile')"
      />
      <CToggler
        in-header
        class="ml-3 d-md-down-none"
        @click="$store.commit('toggleSidebarDesktop')"
      />
      <CHeaderBrand class="mx-auto d-lg-none" to="/dashboard">
        <img
          src="../assets/fundoAllto.d74dcfe7.png"
          class="mx-auto d-lg-none d-sm-none d-md-none"
          height="48"
          alt="Logo"
        />
      </CHeaderBrand>

      <CHeaderNav class="d-md-down-none mr-auto">
        <CHeaderNavItem class="px-3">
          <CHeaderNavLink to="/dashboard"> Dashboard </CHeaderNavLink>
        </CHeaderNavItem>
      </CHeaderNav>

      <CHeaderNav class="mr-4">
        <CHeaderNavItem class="mx-2">
          <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
          >
            <template #toggler>
              <CHeaderNavLink>
                <div class="divNotification">
                  <CIcon
                    class="descriptionNotification"
                    name="cil-bell"
                  ></CIcon>
                  <span v-show="numNotificação > 0" class="spanotofication">{{
                    numNotificação
                  }}</span>
                </div>
              </CHeaderNavLink>
            </template>
            <div class="dropdown-notificacao">
              <CDropdownHeader tag="div" class="text-center;" color="primary">
                <h5
                  style="color: #fff;
                  
    text-align-last: center;"
                >
                  Avisos
                </h5>
              </CDropdownHeader>

              <div class="dropdown-notificacao">
                <CDropdownItem
                  id="dropNotificacao"
                  v-show="
                    notificacao.typenotification == 'Mensagem' ||
                      notificacao.typenotification == 'Evolução' ||
                      notificacao.typenotification == 'Consulta' ||
                      notificacao.typenotification == 'Avaliação' ||
                      notificacao.typenotification == 'Curso' ||
                      notificacao.typenotification == 'Palestra' ||
                      notificacao.typenotification == 'Protocolo' ||
                      notificacao.typenotification == 'Sem Guia' ||
                      notificacao.typenotification == 'Aniversario' ||
                      notificacao.typenotification == 'Não compareceu'
                  "
                  @click="
                    perfilMensagem(
                      notificacao.text,
                      notificacao.typenotification,
                      notificacao.idconsulta,
                      notificacao.id,
                      notificacao.iduser
                    )
                  "
                  v-for="(notificacao, index) of notificacaoDesc"
                  :key="index"
                >
                  <div class="grid">
                    <div class="grid-notificacao">
                      <p>{{ notificacao.typenotification }}</p>

                      <p :class="notificacao.classe">
                        {{ notificacao.dataconsulta }}
                      </p>
                    </div>
                    <p>{{ notificacao.name_patient }}</p>
                  </div>
                </CDropdownItem>
              </div>
            </div>
          </CDropdown>
        </CHeaderNavItem>
        <!-- Adiciona o item de menu da conta com dropdown -->
        <TheHeaderDropdownAccnt />
      </CHeaderNav>

      <CSubheader class="px-3">
        <CBreadcrumbRouter class="border-0 mb-0" />
      </CSubheader>
    </CHeader>
  </div>
</template>

<script>
// importa menu da conta com dropdown
import moment from "moment";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      buttonsProfi: false,
      numNotificação: 0,
      modalMensagem: false,
      modalMsgPro: false,
      notificacaoDesc: [],
      texto: "",
      nameTypeUser: "",
      largeModal: false,
      userType: "",
      dataAtual: "",
      dataRes: "",
      title: "",
      // Validação de visu dos btn msg
      visuBtns: true,
      btnVerC: false,
      // notificação post
      tipo_notificacao: "",
      text: "",
      id_consulta: "",
      id_profissional: "",
      name_profissional: "",
      texto: "",
      profissionalSelecionado: "",
      listaProfissionais: [{ label: "", value: "" }],
      mensagem: "",
      id: "",

      idUser: "",
    };
    // enviar msg
  },
  methods: {
    // Notificação evolução
    validarEvolucao() {
      let dataAtual = moment().format("YYYY-MM-DD");

      // validar admin
      let admin = localStorage.getItem("type_name");
      if (
        admin === "Administrador" ||
        localStorage.getItem("type_name") == "Profissional" || admin === "Administrador-master"
      ) {
        this.$http
          .get(`${process.env.VUE_APP_API_BASE_URL}notificacao-evolucao`)
          .then((res) => res.json())
          .then((res) => {
            if (res.length > 0) {
              this.dataAtual = moment().format("YYYY-MM-DD");
              this.dataRes = moment(res[0].date_at ? res[0].date_at : "-")
                .add(1, "days")
                .format("YYYY-MM-DD");
              this.id_profissional = res[0].id_professional;
              this.id_consulta = res[0].id;
              this.name_profissional = res[0].name;
              this.typeNotification = res[0].typenotification;
            }

            if (this.dataAtual && this.dataRes) {
              this.$http.post(
                `${process.env.VUE_APP_API_BASE_URL}auto-notificacao/evolucao`,
                {
                  tipo_notificacao: "Evolução",
                  text: "Pendência do envio de evolução..",
                  id_consulta: this.id_consulta,
                  id_profissional: this.id_profissional,
                  data_atual: this.dataAtual,
                  data_res: this.dataRes,
                }
              );
            }
          });
      }
    },
    notiEvolucao() {
      let tipo_user = localStorage.getItem("type_name");
      let id = localStorage.getItem("id");

      if (tipo_user == "Administrador" ||tipo_user == "Administrador-master" ) {
        this.$http
          .get(`${process.env.VUE_APP_API_BASE_URL}admin/notificacoes`)
          .then((res) => res.json())
          .then((res) => {
            if (res.length >= 1 && res[0].status_admin == "0") {
              this.numNotificação = res.length;
              this.notificacaoDesc = res;
            }
          });
      }
    },
    abrirModal() {
      this.modalMensagem = true;
      this.largeModal = false;
    },
    enviarMensagem() {
      this.visto();

      if (this.profissionalSelecionado) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}usuario/cadastrar-notificacoes`,
            {
              idProfissional: this.profissionalSelecionado,
              typeNotification: "Mensagem",
              idUser: localStorage.getItem("id"),
              text: this.texto,
              typeUser: localStorage.getItem("type_name"),
            }
          )
          .then(() => {
            this.modalMensagem = false;
          });
      }
    },

    // Demais tipos dados referente notificações
    async listaNotificação() {
      let id = localStorage.getItem("id");
      let type_name = localStorage.getItem("type_name");
      if (type_name == "Profissional") {
        this.visuBtns = false;
      }

      if (localStorage.getItem("type") == 2) {
        await this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}profissional-notificacoes/${id}`
          )
          .then((res) => res.json())
          .then((res) => {
            this.numNotificação = res.length;
            res.forEach((item) => {
              if (res.type_user == "1") {
                res.nameUser = "Administração";
              }
            });

            this.notificacaoDesc = res;
            // this.notificacaoDesc.forEach((item) => {
            //   item.dataconsulta = moment(item.dataconsulta).format(
            //     "DD/MM/YYYY"
            //   );
            // });

            this.notificacaoDesc.forEach((elem) => {
              const nomePaciente = elem.name_patient;
              const nomeFormatado =
                nomePaciente.charAt(0).toUpperCase() +
                nomePaciente.slice(1).toLowerCase();
              elem.name_patient = nomeFormatado;
            });
          });
        await this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}profissional-notificacoes/aniversario/${id}`
          )
          .then((res) => res.json())
          .then((res) => {
            this.numNotificação = this.numNotificação + res.length;

            this.notificacaoDesc = [...this.notificacaoDesc, ...res];

            // this.notificacaoDesc = [...this.notificacaoDesc,res]

            this.notificacaoDesc.forEach((item) => {
              item.dataconsulta = moment(item.dataconsulta).format(
                "DD/MM/YYYY"
              );
            });

            this.notificacaoDesc.forEach((elem) => {
              const nomePaciente = elem.name_patient;
              const nomeFormatado =
                nomePaciente.charAt(0).toUpperCase() +
                nomePaciente.slice(1).toLowerCase();
              elem.name_patient = nomeFormatado;
            });
          });
      } else if (type_name == "Recepcionista") {
        await this.$http
          .get(
            `${process.env.VUE_APP_API_BASE_URL}auto-notificacao-recepcionista`
          )
          .then((res) => res.json())
          .then((res) => {
            this.numNotificação = res.length;
            this.notificacaoDesc = res;
            this.notificacaoDesc.forEach((item) => {
              item.dataconsulta = moment(item.dataconsulta).format(
                "DD/MM/YYYY"
              );
            });

            this.notificacaoDesc.forEach((elem) => {
              
              const nomePaciente = elem.name_patient;
              const nomeFormatado =
                nomePaciente.charAt(0).toUpperCase() +
                nomePaciente.slice(1).toLowerCase();
              elem.name_patient = nomeFormatado;
            });
          });
      }
      

    
      this.notificacaoDesc.forEach((elem) => {
      
      });
    },
    visto(notificacao) {
      if (notificacao?.typenotification == "Aniversario") {
        this.$http
          .post(
            `${process.env.VUE_APP_API_BASE_URL}profissional-notificacoes/visto/${notificacao.id}`
          )
          .then((res) => {
            this.numNotificação = this.numNotificação - 1;
          });
        return;
      }
      let typeName = localStorage.getItem("type_name");
      if (this.btnVerC) {
        if ((typeName == "Administrador " || typeName == "Administrador-master") && this.id_consulta) {
          this.$http
            .post(
              `${process.env.VUE_APP_API_BASE_URL}admin-notificacoes-status/${this.id_consulta}`
            )
            .then((res) => res.json())
            .then((res) => {
              this.numNotificação = 0;
              this.listaNotificação;
              this.largeModal = false;
            });
        } else if (typeName == "Profissional" && this.id_consulta) {
          this.$http
            .post(
              `${process.env.VUE_APP_API_BASE_URL}profissional-notificacoes-status/${this.id_consulta}`
            )
            .then((res) => res.json())
            .then((res) => {
              if (this.numNotificação > 0) {
                this.numNotificação = this.numNotificação - 1;
              }
              this.listaNotificação;
              this.largeModal = false;
            });
        }
      } else {
        this.$http
          .post(`${process.env.VUE_APP_API_BASE_URL}all-notificacoes-status`, {
            user: localStorage.getItem("type_name"),
            id: this.id,
          })
          .then((res) => res.json())
          .then((res) => {
            if (this.numNotificação > 0) {
              this.numNotificação = this.numNotificação - 1;
            }
            this.listaNotificação;
            this.largeModal = false;
          });
      }

      
    },
    perfilMensagem(text, typenotification, idconsulta, id, idUser) {
      // if (typenotification === "Evolução") {
      //   this.btnVerC = true;
      //   this.id_consulta = idconsulta;
      //   this.id = id;
      //   this.texto = text;
      //   this.largeModal = true;
      // } else
      if (typenotification === "Aniversario") {
        if (this.$route.name === "Pacientes") {
          const currentQuery = { ...this.$route.query };
          currentQuery.id = idUser;
          this.$router.replace({
            name: "Pacientes",
            query: currentQuery,
            params: {
              voltar: "consultas",
            },
          });
          this.visto({ typenotification, idUser, id });
          window.location.reload();
        } else {
          this.$router.push({
            name: "Pacientes",
            query: { type: "b", id: idUser },
            params: {
              voltar: "consultas",
            },
          });

          this.visto({ typenotification, idUser, id });
        }
      } else if (
        typenotification === "Consulta" ||
        typenotification === "Avaliação" ||
        typenotification === "Curso" ||
        typenotification === "Palestra" ||
        typenotification === "Protocolo" ||
        typenotification === "Sem Guia" ||
        typenotification === "Evolução" ||
        typenotification ==="Não compareceu"
      ) {
        this.id_consulta = idconsulta;
        this.id = id;
        this.visto({ typenotification, idUser, id });
        this.perfilConsulta();
      } else {
        this.id = id;
        this.texto = text;
        this.largeModal = true;
        this.btnVerC = false;
      }
    },

    visualizaNotificacao() {
      let id = localStorage.getItem("id");
    },
    perfilConsulta() {
      if (this.$route.name == "Consultas" && this.$route.query.type == "b") {
        
        const currentQuery = { ...this.$route.query };
        currentQuery.id = this.id_consulta;
        this.$router.replace({
          name: "Consultas",
          query: currentQuery,
          params: {
            voltar: "consultas",
          },
        });
        window.location.reload();
      } else {
        this.$router.push({
          name: "Consultas",
          query: { type: "b", id: this.id_consulta },
          params: {
            voltar: "consultas",
          },
        });
        this.largeModal = false;
      }
    },
    listarProfissionais() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.listaProfissionais.push({
              label: item.name,
              value: item.id,
            });
          });
        });
    },
  },
  mounted() {
    this.userType = localStorage.getItem("type_name");
    this.listaNotificação();
    this.validarEvolucao();
    this.notiEvolucao();
    this.listarProfissionais();
  },
};
</script>

<style scoped>
.dropdown-item {
  padding: 0em 1em;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.dropdown-item p {
  margin: 0.5em;
}
.divNotification {
  position: relative;
}
.spanotofication {
  position: absolute;
  top: -5px;
  right: -0.8em;
  background-color: rgba(255, 0, 0, 1);
  color: white;
  border-radius: 100%;
  width: 15px;
  height: 20px;
  text-align: center;
  font-size: 10pt;
}
.grid-notificacao {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.grid {
  display: grid;
  grid-template-columns: 240px 1fr;
  align-content: space-between;
  justify-content: space-between;
}

@media (max-width: 574px) {
  .header-brand {
    background-color: #c3c3c3;
  }
}
</style>
